// Links de la app en las tiendas. Mientras la app no esté en la tienda de ese
// sistema, el aviso ofrece instalar la web como app desde el navegador.
// Cuando la app esté publicada en Google Play, poner ANDROID_PUBLISHED en true.
export const ANDROID_PACKAGE = 'ar.com.cupidoconmatesanjuan.app';
export const ANDROID_PUBLISHED = false;
export const ANDROID_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
export const IOS_STORE_URL = '';
